const isNewLogin = () => !!document.referrer.match(/\/login/);

export default isNewLogin;
